import Icon from 'components/Icon'
import Text from 'components/Text'
import useAccordion from './useAccordion'
import InstallmentDropdown from 'components/InstallmentDropdown'
import isMobile from '@mobi/utils/browser/isMobile'
import { focusInElement } from 'utils/accessibility'
import storage from 'utils/storage'
import './Accordion.scss'

function Accordion({
  id,
  isDropdown,
  isDropdownButtonWithoutPadding,
  hasCardIcon,
  dataUnique,
  dataTest,
  ariaLabel,
  dropdownContentDataTest,
  titleAriaLabel,
  ...props
}) {
  const { toggleAccordion, isActive, contentRef } = useAccordion({
    ...props,
  })

  const isActiveFaqStorage = storage.session.getItem('isActiveFaq')

  if (isDropdown) {
    return (
      <div
        className={
          !isDropdownButtonWithoutPadding
            ? `accordion --isdropdown ${props.className}`
            : `accordion --isdropdown ${props.className} buttonWithoutPadding`
        }
      >
        {props.title && (
          <div
            className="container-options-title"
            aria-label={titleAriaLabel}
            role={titleAriaLabel ? 'heading' : null}
          >
            {hasCardIcon && (
              <div className="container-icon-card">
                <Icon iconId="iconCartao" />
              </div>
            )}
            <p
              data-contrast="text"
              className="title"
              aria-hidden={!!titleAriaLabel}
            >
              {props.title}
            </p>
          </div>
        )}
        <button
          className={`button ${isActive}`}
          aria-haspopup="listbox"
          aria-expanded={!!isActive}
          data-unique="3d632090-5f0f-4593-8c4b-d2b389d2c1d1"
          onClick={(ev) => toggleAccordion(ev)}
          id={`accordion-${id}`}
        >
          <InstallmentDropdown
            valueInstallment={props.valueInstallment}
            highlight={props.highlight}
            isActive={isActive}
          />
          <Icon iconId={'arrowAccordion'} />
        </button>
        <div
          ref={contentRef}
          aria-hidden={!isActive}
          className={`content ${!isActive ? 'closed' : 'opened'}`}
          onClick={(ev) =>
            props.closeAccordion && setTimeout(() => toggleAccordion(ev), 20)
          }
          tabIndex={isActive ? 0 : -1}
          data-test={dropdownContentDataTest}
        >
          <div
            className="content-inner"
            aria-label="Selecione uma opção de parcelamento"
            role="radiogroup"
          >
            {props.children}
          </div>
        </div>
        {!isActive && (
          <>
            <div
              role="button"
              className="installmentOptions"
              data-contrast="price-feature"
              data-unique="f2871ca8-5b00-4350-af32-20e46a91a324"
              onClick={(e) => {
                toggleAccordion(e)
                focusInElement(`#accordion-${id}`)
              }}
              data-test="installment-options-accordion"
              tabIndex={0}
            >
              <Text p size={2}>
                Ver opções de parcelamento
              </Text>
            </div>
            <div
              className="discount"
              data-contrast="price-feature"
              data-test="discount-percentage"
            >
              <Text p size={2}>
                <span aria-hidden="true">🔥</span>
                {`${props.valueInstallment.discount} ${
                  isMobile ? `desc` : `de desconto`
                }`}
              </Text>
            </div>
          </>
        )}
      </div>
    )
  }

  const isFaq =
    props.makeLocation === 'faq' &&
    (isActiveFaqStorage === false
      ? `Fechar FAQ: ${props.makeText}`
      : `Abrir FAQ: ${props.makeText}`)

  const makeText =
    props.makeText &&
    (isFaq || `${props.makeText} ${isActive ? 'fechado' : 'aberto'}`)

  return (
    <div className={`accordion ${props.className}`}>
      <button
        className={`button ${isActive}`}
        aria-controls={`data-accordion-${id}`}
        aria-expanded={!!isActive}
        data-unique={dataUnique}
        data-test={dataTest}
        aria-label={ariaLabel}
        data-make-location={props.makeLocation}
        data-make-position={props.makePosition}
        data-make-actionoutcome={props.MakeActionOutcome}
        data-make-element={props.makeElement}
        data-make-text={makeText || ''}
        data-make-product-id={props.makeProductId}
        data-make-product-brand={props.makeProductBrand}
        data-make-product-position={props.makeProductPosition}
        data-make-product-price={props.makeProductPrice}
        data-make-product-text={props.makeProductText}
        onClick={(ev) => toggleAccordion(ev)}
      >
        {props.title ? (
          <Text
            h3
            data-contrast="text"
            className="title button-title"
            aria-hidden={ariaLabel ? 'true' : 'false'}
            data-test="accordion-title"
          >
            {props.title}
          </Text>
        ) : null}
        <Icon iconId={'arrowAccordion'} />
      </button>
      <div
        aria-hidden={!isActive}
        ref={contentRef}
        className={`content ${!isActive ? 'closed' : 'opened'}`}
        onClick={(ev) => props.closeAccordion && toggleAccordion(ev)}
      >
        <div className="content-inner" data-test="accordion-content-inner">
          {props.children}
        </div>
      </div>
    </div>
  )
}

export default Accordion
